import { useQuery } from "@tanstack/react-query";
import { ClientInferResponseBody } from "@ts-rest/core";
import { apiContract } from "tekkr-common/dist/model/api/api.contract";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

export function useScheduledProjectMeetingsQuery() {
    const { project } = useProject();
    return useQuery({
        queryKey: ["project", project.id, "scheduled-meetings"],
        queryFn: async () => {
            const res = await apiClient.getScheduledProjectMeetings({
                params: {
                    id: project.id,
                },
            });
            const body = res.body as ClientInferResponseBody<typeof apiContract.getScheduledProjectMeetings, 200>;
            return body.data;
        },
        refetchInterval: 3_000,
    });
}
